import React from 'react';
import {
	Input,
	Select,
	Form,
	Modal,
	DatePicker,
	Upload,
	message,
	Button,
	Icon,
	Col,
	Row,
	Drawer,
	Descriptions,
	Badge,
	Statistic,
	Tag
} from 'antd';
import moment from 'moment';

const DerWareHousePickUpDetail =(props)=>{
	
	const {onCancel,visible,item} =props
	
	let width = window.innerWidth <768 ? window.innerWidth*0.8 :window.innerWidth*0.35
	return (

	<Drawer   title={item.partnerOrderNo?<span>单号:{item.partnerOrderNo}</span>:<span>无订单号</span>}     placement="right"      closable={false}      onClose={onCancel}    visible={visible}  width={width}  >
	<Descriptions title="试算详情" layout="vertical" bordered>
		<Descriptions.Item label="提货货值"><Statistic value={item.pickUpValue/100} precision={2} valueStyle ={{fontSize:'15px',fontWeight:'bold'}}/></Descriptions.Item>
		<Descriptions.Item label="可提货值"><Statistic value={item.availableValue/100} precision={2} valueStyle ={{fontSize:'15px',fontWeight:'bold'}}/></Descriptions.Item>
		<Descriptions.Item label="需新增还款总金额"><Statistic value={item.suggestAddRepaymentAmount/100} precision={2} valueStyle ={{fontSize:'15px',fontWeight:'bold'}}/></Descriptions.Item>



	  </Descriptions><br/>
	  


      </Drawer>
	
	)

}


export default DerWareHousePickUpDetail;
